import React, { FunctionComponent, useEffect, useState } from "react";
import { Button, hasValue, Input, Modal } from "uxp/components";
import { findSourceById, isStep } from "@utils";
import classNames from "classnames";
import { DataSourceType, IDataSource, IQuery, Param } from "@types";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import './ParamEditor.scss';
import { DEPillInput } from "@components/StepConfigurator/PillInput/DEPillInput";


export function isSourceConfigurable(source: IDataSource): { isConfigurable: boolean, hasConfiguredAll?: boolean } {
    const params = Array.isArray(source?.params) ? source.params : [];
    return {
        isConfigurable: (source?.type === DataSourceType.Query) && params.length > 0,
        hasConfiguredAll: params.every((p) => hasValue(p?.value))
    };
}

interface ParamsEditorProps {
    query: IQuery,
    source: IDataSource,
    onChange: (updatedSource: IDataSource) => void
}

export const ParamsEditor: FunctionComponent<ParamsEditorProps> = ({ source, onChange, query }) => {

    const [show, setShow] = useState(false)

    if (!source || !query) return null

    const _source = findSourceById(query, source.id)
    if (!_source || isStep(_source)) return

    const { isConfigurable, hasConfiguredAll } = isSourceConfigurable(_source)
    if (!isConfigurable) return null
    return <>
        <div
            className={classNames(
                'lqe_queryparamseditor__button',
                {
                    'lqe_queryparamseditor__button--invalid': !hasConfiguredAll,
                }
            )}
            onClick={() => setShow(true)}
        >
            <FontAwesomeIcon icon={['fas', 'tools']} />
        </div>

        <ParamEditorModal
            show={show}
            onClose={() => setShow(false)}
            source={_source}
            onSave={(updated) => {
                onChange({ ...updated })
                setShow(false)
            }}
            query={query}
        />
    </>
}

interface ParamsEditorModalProps {
    show: boolean,
    onClose: () => void,
    source: IDataSource,
    onSave: (updatedSource: IDataSource) => void,
    query: IQuery
}
export const ParamEditorModal: FunctionComponent<ParamsEditorModalProps> = ({ show, onClose, source, onSave, query }) => {

    const [params, setParams] = useState<Param[]>([])

    useEffect(() => {
        setParams(source?.params || [])
    }, [source, show])

    function renderEditor() {
        return <div
            className={classNames('lqe_queryparamseditor')}
        >
            {(params || []).map((param, i) => {
                return <div className="lqe_queryparamseditor__param">
                    <div className="lqe_queryparamseditor__param-label">{param.name}</div>
                    <div className="lqe_queryparamseditor__param-value">

                        <DEPillInput
                            value={param?.value||''}
                            onChange={v => setParams(prev => {
                                prev[i].value = v;

                                return [...prev]
                            })}
                            query={query}
                        />
                    </div>
                </div>
            })}
        </div>
    }

    return <Modal
        show={show}
        onClose={onClose}
        title={`Configure parameters for ${source?.name}`}
        className="lqe_queryparamseditor__modal_container"
    >
        {/* TODO:: may be render some description here  */}

        {renderEditor()}

        <div className="lqe_queryparamseditor__modal_footer">
            <Button title="Save & Continue" onClick={() => onSave({ ...source, params: params })} />
        </div>
    </Modal>
}